import { getSelectedBG } from 'store/selectedBubble/reducer';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGlobal } from 'store';
import { Sprite } from '@inlet/react-pixi';
import BG from 'story/BG.json';
import { CachedSprites, fetchImage } from 'lib/utils';
import { setBGLoaded } from 'store/resources';

export const BackgroundComponent: FC = () => {
  const { height, width } = useSelector(getGlobal);
  const currentBGID = useSelector(getSelectedBG);
  const dispatch = useDispatch();

  const [backs, setBacks] = useState<CachedSprites>([]);
  const currentBG = backs[currentBGID] || { height, width };

  useEffect(() => {
    Promise.allSettled(BG.map((b, id) => fetchImage(id, b.img))).then((bgs) => {
      // @ts-ignore
      setBacks(bgs.reduce((a, b) => ({ ...a, ...(b.value || {}) }), {}));
      dispatch(setBGLoaded(true));
    });
  }, []);

  const imageAspect = currentBG.height / currentBG.width;
  const screenAspect = height / width;

  let imageHeight = height;
  let imageWidth = width;

  if (imageAspect > 1) {
    if (screenAspect > imageAspect) {
      imageHeight = height;
      imageWidth = height / imageAspect;
    } else {
      imageWidth = width;
      imageHeight = width * imageAspect;
    }
  } else {
    imageHeight = height;
    imageWidth = height / imageAspect;
  }

  return (
    <>
      {Object.values(backs).map((b, id) =>
        b.texture ? (
          <Sprite
            key={BG[id].id}
            alpha={BG[id].id === currentBGID ? 1 : 0}
            texture={b.texture}
            height={imageHeight}
            width={imageWidth}
            position={[width / 2, height / 2]}
            anchor={0.5}
          />
        ) : null
      )}
    </>
  );
};
